import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    zoom:        1,
    displayMode: "fitToWidth",
};

const dashboardSlice = createSlice({
    name: 'dashboard',
    initialState,
    reducers: {
        setZoom: (state, action) => {
            state.zoom = action.payload;
        },
        setDisplayMode: (state, action) => {
            state.displayMode = action.payload;
        },
    },
});

export const dashboardAction = dashboardSlice.actions;
export const dashboardReducer = dashboardSlice.reducer;